import { SystemUserDetailDTO, SystemUserInfoDTO, PersonInfoDTO, SystemUserContactInfoDTO, IUploadedFileDetailDTO } from "api/swagger/ApiClient";
import { UserDetail, UserInfo } from "model/business-base";
import { PersonInfo } from "model/business-types";
import { UploadedFile } from "../../../model/essential-types";

export class EssentialTypesMapping {
  mapSystemUserDetailToUserInfo(dto: SystemUserDetailDTO): UserInfo {
    return {
      id: dto.id,
      uniqueid: dto.uniqueId,
      username: dto.loginName,
      name: dto.fullName,
      initials: dto.initials
    }
  }

  mapSystemUserDetailToUserDetail(dto: SystemUserDetailDTO): UserDetail {
    return {
      id: dto.id,
      uniqueid: dto.uniqueId,
      username: dto.loginName,
      name: dto.fullName,
      initials: dto.initials,
      jobTitle: dto.jobTitle,
      mail: dto.email,
      phone: dto.mobilePhone,
      countriesContactEmail: dto.countriesContactEmail
    }
  }

  mapSystemUserContactInfoToUserDetail(dto: SystemUserContactInfoDTO): UserDetail {
    return {
      id: dto.id,
      uniqueid: dto.uniqueId,
      username: dto.loginName,
      name: dto.fullName,
      initials: dto.initials,
      jobTitle: dto.jobTitle,
      mail: dto.email,
      phone: dto.mobilePhone,
      countriesContactEmail: dto.countriesContactEmail
    }
  }

  mapSystemUserInfoToUserInfo(dto: SystemUserInfoDTO): UserInfo {
    return {
      id: dto.id,
      uniqueid: dto.uniqueId,
      username: dto.loginName,
      name: dto.fullName,
      initials: dto.initials
    }
  }

  mapPersonInfoToPersonInfo(dto: PersonInfoDTO): PersonInfo {
    return {
      name: dto.fullName,
      initials: dto.initials
    }
  }

  mapUploadedFileDetailToUploadedFile(dto: IUploadedFileDetailDTO): UploadedFile {
    return {
      id: dto.id,
      fileName: dto.fileName,
      extension: dto.extension,
      sizeInBytes: dto.sizeInBytes,
      storageFileId: dto.storageFileId,
      uploadedOn: dto.uploadedOn,
      uploadedBy: this.mapSystemUserInfoToUserInfo(dto.uploadedBy)
    }
  }
}
